import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { CodCreateComponent } from './cod/components/cod-create/cod-create.component';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { CodReviewComponent } from './cod/components/cod-review/cod-review.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { ReportComponent } from './report/report.component';
import { canActivateAdmin } from './auth/guards/admin.guard';
import { canActivateReporting } from './auth/guards/reporting.guard';
import { canActivateUser } from './auth/guards/user.guard';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { MaintenanceGuard } from './maintenance/guards/maintenance.guard';

const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
        canActivate: [AutoLoginPartialRoutesGuard, MaintenanceGuard, canActivateUser]
    },
    {
        path: 'cod/create',
        component: CodCreateComponent,
        canActivate: [AutoLoginPartialRoutesGuard, MaintenanceGuard, canActivateUser]
    },
    {
        path: 'cod/:id/review',
        component: CodReviewComponent,
        canActivate: [AutoLoginPartialRoutesGuard, MaintenanceGuard, canActivateUser]
    },
    {
        path: 'user-management',
        component: UserManagementComponent,
        canActivate: [AutoLoginPartialRoutesGuard, MaintenanceGuard, canActivateAdmin]
    },
    {
        path: 'report',
        component: ReportComponent,
        canActivate: [AutoLoginPartialRoutesGuard, MaintenanceGuard, canActivateReporting]
    },
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.module').then(m => m.AuthGmsAngularClientModule)
    },
    {
        path: 'maintenance',
        component: MaintenanceComponent
    },
    {
        path: '**',
        redirectTo: ''
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
